/* ═══════════════════════════════════════════════════════════════
   Bailey & Coco — Personalised Bottle v4
   JavaScript — Multi-Dog + Colour Selection + Approval Flow
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── Config ──────────────────────────────────────────────────
  var UPLOAD_ENDPOINT = 'https://bc-upload.andrewsimpson661.workers.dev/upload';

  // Colour hex map — covers all bottle products. New colours are auto-detected
  // from variant data; this map provides the swatch fill colour.
  // Add new entries here when new colours are introduced.
  var COLOUR_HEX = {
    // Switch Bottle
    'arctic-white': '#FFFFFF',
    'black': '#1a1a1a',
    'blossom-pink': '#F4C2C2',
    'sage-green': '#B2AC88',
    'midnight-blue': '#191970',
    'honey-cream': '#E8D5B7',
    'pine-green': '#01796F',
    'lilac-haze': '#C8A2C8',
    'slate-grey': '#708090',
    // Pulse Bottle
    'pure-white': '#FFFFFF',
    'carbon-black': '#1a1a1a',
    'coastal-blue': '#5B9BD5',
    'tangerine': '#FF9966',
    'organic-grape': '#6B3FA0',
    // 500ml Original
    'all-white': '#FFFFFF',
    'all-black': '#1a1a1a',
    'mellow-yellow': '#F5D76E',
    'gravity-grey': '#808080'
  };

  // Colours that need a visible border on white backgrounds
  var WHITE_COLOURS = ['arctic-white', 'pure-white', 'all-white'];

  // ── State ─────────────────────────────────────────────────
  var state = {
    dogCount: 0,        // 0 = not selected, 1-5
    dogOption: '',       // exact Shopify value e.g. '2 Dogs'
    colour: '',          // exact Shopify value e.g. 'Arctic White'
    dogs: [],            // [{photo, photoUrl, uploading, uploaded, name}, ...]
    fontStyle: 'classic',
    matchedVariant: null // the matched variant object or null
  };

  // ── DOM refs ──────────────────────────────────────────────
  var $ = function(sel) { return document.querySelector(sel); };
  var $$ = function(sel) { return document.querySelectorAll(sel); };

  var els = {};

  function cacheDom() {
    // Steps
    els.step1         = $('#bc-step-1');
    els.step2         = $('#bc-step-2');
    els.step3         = $('#bc-step-3');
    els.step4         = $('#bc-step-4');
    els.step1Num      = $('#bc-step1-num');
    els.step2Num      = $('#bc-step2-num');
    els.step3Num      = $('#bc-step3-num');
    els.step4Num      = $('#bc-step4-num');

    // Dog pills
    els.dogPills      = $$('#bc-dog-pills .bc-dog-pill');

    // Colour swatches
    els.colourSwatches = $$('#bc-colour-swatches .bc-colour-swatch');
    els.colourName    = $('#bc-colour-name');

    // Upload
    els.uploadZones   = $('#bc-upload-zones');
    els.uploadTemplate = $('#bc-upload-template');
    els.photoTip      = $('#bc-photo-tip');
    els.photoTitlePlural = $('#bc-photo-title-plural');

    // Names
    els.nameInputs    = $('#bc-name-inputs');
    els.nameTemplate  = $('#bc-name-template');
    els.nameTitlePlural = $('#bc-name-title-plural');
    els.fontBtns      = $$('#bc-font-styles .bc-style-btn');
    els.fontPreviews  = $$('.bc-style-btn__preview');

    // Form
    els.addForm       = $('#bc-add-form');
    els.addBtn        = $('#bc-add-btn');
    els.ctaText       = $('#bc-cta-text');
    els.variantInput  = $('#bc-variant-id');
    els.hiddenProps   = $('#bc-hidden-props');

    // Price
    els.priceDisplay  = $('#bc-price-display');
    els.klarnaText    = $('#bc-klarna-text');

    // Sticky CTA
    els.stickyBtn     = $('#bc-sticky-btn');
    els.stickyText    = $('#bc-sticky-text');
    els.stickyCta     = $('#bc-sticky-cta');

    // Gallery
    els.galleryMain   = $('#bc-gallery-main');
    els.galleryThumbs = $('#bc-gallery-thumbs');

    // Process
    els.proc1         = $('#bc-proc-1');
    els.proc2         = $('#bc-proc-2');

    // FAQ
    els.faqBtns       = $$('.bc-faq__question');
  }


  // ── Helpers ───────────────────────────────────────────────

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  function sanitizeName(value) {
    var cleaned = value.replace(/[\u{1F600}-\u{1F64F}]/gu, '')
                       .replace(/[\u{1F300}-\u{1F5FF}]/gu, '')
                       .replace(/[\u{1F680}-\u{1F6FF}]/gu, '')
                       .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '')
                       .replace(/[\u{2600}-\u{26FF}]/gu, '')
                       .replace(/[\u{2700}-\u{27BF}]/gu, '')
                       .replace(/[\u{FE00}-\u{FE0F}]/gu, '')
                       .replace(/[\u{200D}]/gu, '')
                       .replace(/[\u{20E3}]/gu, '')
                       .replace(/[\u{E0020}-\u{E007F}]/gu, '');
    cleaned = cleaned.replace(/[^a-zA-Z0-9\s\-'&]/g, '');
    cleaned = cleaned.replace(/\s{2,}/g, ' ');
    cleaned = cleaned.replace(/^\s+/, '');
    return cleaned;
  }


  // ── Step 1: Dog Count ─────────────────────────────────────

  function handleDogCountSelect(e) {
    var btn = e.currentTarget;
    var count = parseInt(btn.dataset.count, 10);
    var option = btn.dataset.dogs; // exact Shopify value

    state.dogCount = count;
    state.dogOption = option;

    // Update active pill
    els.dogPills.forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    // Rebuild dogs array preserving existing data
    var newDogs = [];
    for (var i = 0; i < count; i++) {
      newDogs.push(state.dogs[i] || {
        photo: null,
        photoUrl: '',
        uploading: false,
        uploaded: false,
        name: ''
      });
    }
    state.dogs = newDogs;

    // Update plural text
    if (els.photoTitlePlural) els.photoTitlePlural.style.display = count === 1 ? 'none' : '';
    if (els.nameTitlePlural) els.nameTitlePlural.style.display = count === 1 ? 'none' : '';

    rebuildUploadZones();
    rebuildNameInputs();
    updateVariant();
    updateUI();
  }


  // ── Step 2: Colour Selection ──────────────────────────────

  function handleColourSelect(e) {
    var btn = e.currentTarget;
    state.colour = btn.dataset.colour;

    els.colourSwatches.forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    els.colourName.textContent = state.colour;

    updateVariant();
    updateUI();
  }


  // ── Variant Matching ──────────────────────────────────────

  function updateVariant() {
    if (!state.dogOption || !state.colour) {
      state.matchedVariant = null;
      return;
    }

    var variants = window.bcBottleVariants;
    var config = window.bcBottleConfig || { dogsOptionPosition: 1, colourOptionPosition: 2 };
    if (!variants) {
      console.warn('bcBottleVariants not found');
      return;
    }

    var dogsKey = 'option' + config.dogsOptionPosition;
    var colourKey = 'option' + config.colourOptionPosition;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v[dogsKey] === state.dogOption && v[colourKey] === state.colour) {
        state.matchedVariant = v;
        els.variantInput.value = v.id;

        // Update price
        els.priceDisplay.textContent = formatMoney(v.price);

        // Update Klarna
        var thirdPayment = Math.ceil(v.price / 3);
        els.klarnaText.innerHTML = 'or 3 interest-free payments of ' + formatMoney(thirdPayment) + ' with <strong>Klarna</strong>';

        // Update URL
        try {
          var url = new URL(window.location);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } catch(e) { /* ignore */ }

        // Swap gallery to variant's colour image
        if (v.featured_image && v.featured_image.src) {
          var firstImg = els.galleryMain ? els.galleryMain.querySelector('.bc-gallery__image[data-index="0"]') : null;
          if (firstImg && firstImg.tagName === 'IMG') {
            var newSrc = v.featured_image.src.replace(/^\/\//, 'https://');
            // Add width param for consistent sizing
            if (newSrc.indexOf('width=') === -1) {
              newSrc += (newSrc.indexOf('?') > -1 ? '&' : '?') + 'width=800';
            }
            firstImg.src = newSrc;
            firstImg.alt = v.featured_image.alt || '';
          }
          // Activate first slide and its thumbnail
          $$('.bc-gallery__image').forEach(function(el) { el.classList.remove('is-active'); });
          if (firstImg) firstImg.classList.add('is-active');
          var firstThumb = els.galleryThumbs ? els.galleryThumbs.querySelector('[data-index="0"]') : null;
          if (firstThumb) {
            $$('.bc-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
            firstThumb.classList.add('is-active');
            // Update thumb image too
            var thumbImg = firstThumb.querySelector('img');
            if (thumbImg) {
              var thumbSrc = v.featured_image.src.replace(/^\/\//, 'https://');
              if (thumbSrc.indexOf('width=') === -1) {
                thumbSrc += (thumbSrc.indexOf('?') > -1 ? '&' : '?') + 'width=200';
              } else {
                thumbSrc = thumbSrc.replace(/width=\d+/, 'width=200');
              }
              thumbImg.src = thumbSrc;
            }
          }
        }

        return;
      }
    }

    // No match found
    state.matchedVariant = null;
    console.warn('No variant match for:', state.dogOption, '+', state.colour);
  }


  // ── Dynamic Upload Zones ──────────────────────────────────

  function rebuildUploadZones() {
    if (!els.uploadZones || !els.uploadTemplate) return;
    els.uploadZones.innerHTML = '';

    for (var i = 0; i < state.dogCount; i++) {
      var clone = els.uploadTemplate.content.cloneNode(true);
      var wrap = clone.querySelector('.bc-upload-zone-wrap');
      var label = clone.querySelector('.bc-upload-zone-label__text');
      var numBadge = clone.querySelector('.bc-upload-zone-label__num');
      var uploadZone = clone.querySelector('.bc-upload');
      var fileInput = clone.querySelector('.bc-upload__input');
      var defaultZone = clone.querySelector('.bc-upload__default');
      var successZone = clone.querySelector('.bc-upload__success');
      var changeBtn = clone.querySelector('.bc-upload__change');
      var deleteBtn = clone.querySelector('.bc-upload__delete');
      var dogLabel = clone.querySelector('.bc-upload__dog-label');

      wrap.setAttribute('data-dog-index', i);

      if (state.dogCount === 1) {
        label.textContent = "Your dog's photo";
        numBadge.style.display = 'none';
        if (dogLabel) dogLabel.textContent = 'your dog';
      } else {
        label.textContent = "Dog " + (i + 1) + "'s photo";
        numBadge.textContent = (i + 1);
        if (dogLabel) dogLabel.textContent = 'Dog ' + (i + 1);
      }

      // Restore state if photo already uploaded
      if (state.dogs[i] && state.dogs[i].uploaded) {
        defaultZone.style.display = 'none';
        successZone.style.display = '';
      }

      // Bind events. IMPORTANT: pass ALL per-iteration DOM refs into the IIFE so each listener
      // closes over its own elements. Without this, `var defaultZone`, `var fileInput` etc. are
      // hoisted to function scope and every listener ends up using the LAST iteration's values,
      // so clicking Dog 1's zone would actually open Dog N's file chooser. Root cause of the
      // multi-dog upload slot-mismatch bug shipped 2026-04-02.
      (function(index, defaultZone, successZone, fileInput, changeBtn, deleteBtn, uploadZone) {
        defaultZone.addEventListener('click', function() {
          fileInput.click();
        });

        uploadZone.addEventListener('keydown', function(e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target === uploadZone) {
            e.preventDefault();
            if (!state.dogs[index] || !state.dogs[index].photo) fileInput.click();
          }
        });

        fileInput.addEventListener('change', function(e) {
          handlePhotoUpload(index, e);
        });

        changeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          fileInput.click();
        });

        deleteBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          deletePhoto(index);
        });

        // Drag & drop
        uploadZone.addEventListener('dragover', function(e) {
          e.preventDefault();
          if (!state.dogs[index] || !state.dogs[index].photo) {
            defaultZone.style.borderColor = '#D4849A';
            defaultZone.style.background = 'rgba(245,230,235,0.6)';
          }
        });

        uploadZone.addEventListener('dragleave', function(e) {
          e.preventDefault();
          defaultZone.style.borderColor = '';
          defaultZone.style.background = '';
        });

        uploadZone.addEventListener('drop', function(e) {
          e.preventDefault();
          defaultZone.style.borderColor = '';
          defaultZone.style.background = '';
          var files = e.dataTransfer.files;
          if (files && files.length > 0) {
            var dt = new DataTransfer();
            dt.items.add(files[0]);
            fileInput.files = dt.files;
            handlePhotoUpload(index, { target: { files: [files[0]] } });
          }
        });
      })(i, defaultZone, successZone, fileInput, changeBtn, deleteBtn, uploadZone);

      els.uploadZones.appendChild(clone);
    }
  }


  // ── HEIC -> JPEG conversion (hybrid: iOS Safari native canvas, else lazy-loaded heic-to) ────

  var HEIC_TO_CDN_PRIMARY  = 'https://cdn.jsdelivr.net/npm/heic-to@1.4.2/dist/iife/heic-to.js';
  var HEIC_TO_CDN_FALLBACK = 'https://unpkg.com/heic-to@1.4.2/dist/iife/heic-to.js';

  var _heicToLoader = null;

  function loadHeicTo() {
    // heic-to IIFE exposes itself as window.HeicTo (callable function) per its src/iife.js.
    if (window.HeicTo) return Promise.resolve(window.HeicTo);
    if (_heicToLoader) return _heicToLoader;
    _heicToLoader = new Promise(function(resolve, reject) {
      var tried = 0;
      function attempt(src) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = function() {
          if (window.HeicTo) { resolve(window.HeicTo); }
          else { next(); }
        };
        s.onerror = next;
        document.head.appendChild(s);
      }
      function next() {
        tried++;
        if (tried === 1) attempt(HEIC_TO_CDN_FALLBACK);
        else reject(new Error('HEIC converter unavailable'));
      }
      attempt(HEIC_TO_CDN_PRIMARY);
    });
    return _heicToLoader;
  }

  function isIOSSafari() {
    var ua = navigator.userAgent;
    var isIOS = /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isSafari = /Safari/.test(ua) && !/(CriOS|FxiOS|EdgiOS|Chrome|Firefox|Edg)/.test(ua);
    return isIOS && isSafari;
  }

  function nativeCanvasDecode(file) {
    return new Promise(function(resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function() {
        URL.revokeObjectURL(url);
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(function(blob) {
          if (blob) resolve(blob); else reject(new Error('toBlob failed'));
        }, 'image/jpeg', 0.9);
      };
      img.onerror = function() { URL.revokeObjectURL(url); reject(new Error('Native HEIC decode failed')); };
      img.src = url;
    });
  }

  function libraryConvert(file) {
    return loadHeicTo().then(function(fn) {
      // heic-to IIFE resolves to the heicTo function itself (not an object wrapper).
      if (typeof fn !== 'function') throw new Error('HEIC converter not callable');
      return fn({ blob: file, type: 'image/jpeg', quality: 0.9 });
    });
  }

  function heicToJpeg(file) {
    var isHeic = /\.(heic|heif)$/i.test(file.name) || file.type === 'image/heic' || file.type === 'image/heif';
    if (!isHeic) return Promise.resolve(file);

    if (isIOSSafari()) {
      return nativeCanvasDecode(file).catch(function() { return libraryConvert(file); });
    }
    return libraryConvert(file);
  }


  // ── Image Compression (HEIC-aware, canvas resize before upload) ────

  function compressImage(file, maxDim, quality) {
    return heicToJpeg(file).then(function(source) {
      return new Promise(function(resolve, reject) {
        var wasConverted = source !== file;
        // If already a small JPEG/PNG and no HEIC conversion was needed, pass through.
        if (!wasConverted && source.size < 1024 * 1024) { resolve(source); return; }

        var img = new Image();
        var url = URL.createObjectURL(source);
        img.onload = function() {
          URL.revokeObjectURL(url);
          var scale = Math.min(1, maxDim / Math.max(img.width, img.height));
          var w = Math.max(1, Math.round(img.width * scale));
          var h = Math.max(1, Math.round(img.height * scale));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          canvas.toBlob(function(blob) {
            var out = blob || source;
            // Hard post-compression size guard (backend fails above ~4.5MB)
            if (out.size > 4 * 1024 * 1024) {
              reject(new Error('Photo is very large. Please try a smaller image or a screenshot.'));
              return;
            }
            resolve(out);
          }, 'image/jpeg', quality);
        };
        img.onerror = function() {
          URL.revokeObjectURL(url);
          if (source.size > 4 * 1024 * 1024) {
            reject(new Error('Photo is very large. Please try a smaller image or a screenshot.'));
          } else {
            resolve(source);
          }
        };
        img.src = url;
      });
    });
  }

  // ── Photo Upload ──────────────────────────────────────────

  function handlePhotoUpload(dogIndex, e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!state.dogs[dogIndex]) return;

    // Validate type
    var allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif', 'image/webp'];
    var fileType = file.type.toLowerCase();
    var fileName = file.name.toLowerCase();
    var validType = allowedTypes.indexOf(fileType) > -1;
    var validExt = /\.(jpg|jpeg|png|heic|heif|webp)$/.test(fileName);
    if (!validType && !validExt) {
      alert('Please upload a photo of your dog. Accepted formats: JPG, PNG, HEIC or WEBP.');
      return;
    }

    // Validate size
    if (file.size > 10 * 1024 * 1024) {
      alert('Photo must be under 10MB. Please choose a smaller file.');
      return;
    }

    state.dogs[dogIndex].photo = file;
    state.dogs[dogIndex].uploading = true;
    state.dogs[dogIndex].uploaded = false;
    updateUI();

    // Compress (HEIC-aware) then upload. Surface any compression-time error (size guard, converter failure) to the user.
    // After HEIC conversion, compressImage always returns a JPEG blob. Rename the outgoing filename so the Worker
    // stores it with .jpg extension (matches actual content for Richie's fulfilment pipeline).
    compressImage(file, 2048, 0.82).then(function(compressed) {
      var outName = file.name;
      if (/\.(heic|heif)$/i.test(outName)) {
        outName = outName.replace(/\.(heic|heif)$/i, '.jpg');
      }
      uploadPhotoToServer(dogIndex, compressed, outName);
    }).catch(function(err) {
      if (!state.dogs[dogIndex]) return;
      state.dogs[dogIndex].uploading = false;
      state.dogs[dogIndex].uploaded = false;
      state.dogs[dogIndex].photo = null;
      state.dogs[dogIndex].photoUrl = '';
      console.error('Photo compression error (dog ' + (dogIndex + 1) + '):', err);
      alert((err && err.message) || 'Could not prepare this photo. Please try a different one.');
      refreshUploadZoneUI(dogIndex);
      updateUI();
    });
  }

  function setSlowUploadHint(dogIndex, show) {
    var wrap = els.uploadZones && els.uploadZones.querySelector('[data-dog-index="' + dogIndex + '"]');
    if (!wrap) return;
    var hint = wrap.querySelector('.bc-upload__slow-hint');
    if (show) {
      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'bc-upload__slow-hint';
        hint.setAttribute('role', 'status');
        hint.style.cssText = 'font-size:12px;color:#666;margin-top:6px;text-align:center;';
        hint.textContent = 'Still uploading — please wait, larger photos can take up to a minute.';
        wrap.appendChild(hint);
      }
    } else if (hint) {
      hint.parentNode.removeChild(hint);
    }
  }

  function uploadPhotoToServer(dogIndex, file, originalName) {
    if (!UPLOAD_ENDPOINT) {
      if (state.dogs[dogIndex]) {
        state.dogs[dogIndex].uploading = false;
        state.dogs[dogIndex].uploaded = true;
        state.dogs[dogIndex].photoUrl = originalName || file.name;
      }
      updateUI();
      return;
    }

    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, 60000);
    var slowHintId = setTimeout(function() { setSlowUploadHint(dogIndex, true); }, 10000);

    fetch(UPLOAD_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/octet-stream',
        'X-Filename': originalName || file.name,
      },
      body: file,
      signal: controller.signal,
    })
    .then(function(response) {
      clearTimeout(timeoutId);
      clearTimeout(slowHintId);
      setSlowUploadHint(dogIndex, false);
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error((data && data.error) || 'Upload failed');
        });
      }
      return response.json();
    })
    .then(function(data) {
      if (!state.dogs[dogIndex]) return; // dog count changed during upload
      if (!data || !data.filename) {
        throw new Error('Upload incomplete, please try again.');
      }
      // Worker returns 200 even when the downstream FTP step rejected the payload.
      // Treat anything other than ok as a real failure so we never ship an order
      // with a filename the backend never actually received.
      if (data.ftp && data.ftp !== 'ok') {
        throw new Error('Upload incomplete. Please try a smaller photo.');
      }
      state.dogs[dogIndex].uploading = false;
      state.dogs[dogIndex].uploaded = true;
      state.dogs[dogIndex].photoUrl = data.filename;
      refreshUploadZoneUI(dogIndex);
      updateUI();
    })
    .catch(function(err) {
      clearTimeout(timeoutId);
      clearTimeout(slowHintId);
      setSlowUploadHint(dogIndex, false);
      if (!state.dogs[dogIndex]) return;
      state.dogs[dogIndex].uploading = false;
      state.dogs[dogIndex].uploaded = false;
      state.dogs[dogIndex].photo = null;
      state.dogs[dogIndex].photoUrl = '';
      console.error('Photo upload error (dog ' + (dogIndex + 1) + '):', err);
      var msg = (err && err.name === 'AbortError')
        ? 'That upload timed out. Please check your connection and try again.'
        : ((err && err.message) || 'Photo upload failed for Dog ' + (dogIndex + 1) + '. Please try again.');
      alert(msg);
      refreshUploadZoneUI(dogIndex);
      updateUI();
    });
  }

  function refreshUploadZoneUI(dogIndex) {
    var wrap = els.uploadZones.querySelector('[data-dog-index="' + dogIndex + '"]');
    if (!wrap) return;
    var defaultZone = wrap.querySelector('.bc-upload__default');
    var successZone = wrap.querySelector('.bc-upload__success');
    var dog = state.dogs[dogIndex];

    if (dog && dog.uploaded) {
      defaultZone.style.display = 'none';
      successZone.style.display = '';
    } else {
      defaultZone.style.display = '';
      successZone.style.display = 'none';
    }
  }

  function deletePhoto(dogIndex) {
    if (!state.dogs[dogIndex]) return;
    state.dogs[dogIndex].photo = null;
    state.dogs[dogIndex].photoUrl = '';
    state.dogs[dogIndex].uploaded = false;
    state.dogs[dogIndex].uploading = false;

    // Reset file input
    var wrap = els.uploadZones.querySelector('[data-dog-index="' + dogIndex + '"]');
    if (wrap) {
      var input = wrap.querySelector('.bc-upload__input');
      if (input) input.value = '';
    }

    refreshUploadZoneUI(dogIndex);
    updateUI();
  }


  // ── Dynamic Name Inputs ───────────────────────────────────

  function rebuildNameInputs() {
    if (!els.nameInputs || !els.nameTemplate) return;
    els.nameInputs.innerHTML = '';

    for (var i = 0; i < state.dogCount; i++) {
      var clone = els.nameTemplate.content.cloneNode(true);
      var group = clone.querySelector('.bc-name-group');
      var label = clone.querySelector('.bc-name-field-label');
      var input = clone.querySelector('.bc-name-input');
      var counter = clone.querySelector('.bc-input__count');

      group.setAttribute('data-dog-index', i);

      if (state.dogCount === 1) {
        label.textContent = "Your dog's name";
      } else {
        label.textContent = "Dog " + (i + 1) + "'s name";
      }

      // Restore existing name
      if (state.dogs[i] && state.dogs[i].name) {
        input.value = state.dogs[i].name;
        counter.textContent = state.dogs[i].name.length + '/21';
      }

      // Bind events
      (function(index) {
        input.addEventListener('input', function(e) {
          handleNameInput(index, e);
        });

        input.addEventListener('paste', function(e) {
          setTimeout(function() {
            var clean = sanitizeName(input.value);
            input.value = clean;
            if (state.dogs[index]) state.dogs[index].name = clean;
            counter.textContent = clean.length + '/21';
            updateFontPreviews();
            updateUI();
          }, 0);
        });
      })(i);

      els.nameInputs.appendChild(clone);
    }
  }

  function handleNameInput(dogIndex, e) {
    var raw = e.target.value;
    var clean = sanitizeName(raw);

    if (clean !== raw) {
      e.target.value = clean;
    }

    if (state.dogs[dogIndex]) {
      state.dogs[dogIndex].name = clean;
    }

    // Update counter
    var group = e.target.closest('.bc-name-group');
    if (group) {
      var counter = group.querySelector('.bc-input__count');
      if (counter) counter.textContent = clean.length + '/21';
    }

    updateFontPreviews();
    updateUI();
  }

  function updateFontPreviews() {
    // Show first dog's name in font previews (or 'Name' if empty)
    var displayName = (state.dogs[0] && state.dogs[0].name) ? state.dogs[0].name : 'Name';
    els.fontPreviews.forEach(function(preview) {
      preview.textContent = displayName;
    });
  }


  // ── Font Style ────────────────────────────────────────────

  function handleFontSelect(e) {
    var btn = e.currentTarget;
    state.fontStyle = btn.dataset.style;

    els.fontBtns.forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    // Refresh hidden props so Smart Cart's FormData read at click time picks up the new font.
    // Without this, Smart Cart sees stale properties[Font]=classic regardless of the user's selection.
    updateUI();
  }


  /* BC_FONT_LABEL - put the real typeface name on the order so production never
     has to translate a slug. Keep this map in step with the @font-face in the
     section and with the font installed in Photoshop. */
  var BC_FONT_LABELS = {
    classic:  'Classic (Georgia)',
    elegant:  'Elegant (Yellowtail)',
    modern:   'Modern (Helvetica Neue / Arial)',
    playful:  'Playful (Comic Sans MS)'
  };
  function bcFontLabel(slug){
    return BC_FONT_LABELS[slug] || slug || '';
  }
  /* Top level (31 Oct 2026): buildProperties() calls this too. Inside rebuildHiddenProps it was
     out of scope, so the mobile sticky Add to Basket threw "bcFontLabel is not defined". */

  // ── Hidden Properties ─────────────────────────────────────

  function rebuildHiddenProps() {
    els.hiddenProps.innerHTML = '';

    function addInput(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      els.hiddenProps.appendChild(input);
    }

    // Dogs count
    addInput('properties[Dogs]', state.dogOption);

    // Colour
    addInput('properties[Colour]', state.colour);

    // Per-dog properties
    for (var i = 0; i < state.dogs.length; i++) {
      var n = i + 1;
      var dog = state.dogs[i];
      addInput('properties[Image_' + n + ']', dog.photoUrl);
      addInput('properties[Name_' + n + ']', sanitizeName(dog.name).trim());
    }




    // Shared font - human-readable for production, raw slug kept hidden
    addInput('properties[Font]', bcFontLabel(state.fontStyle));
    addInput('properties[_Font code]', state.fontStyle || 'classic');
  }


  // ── Gallery ───────────────────────────────────────────────

  function initGallery() {
    if (!els.galleryThumbs) return;

    els.galleryThumbs.addEventListener('click', function(e) {
      var thumb = e.target.closest('.bc-gallery__thumb');
      if (!thumb) return;

      var index = thumb.dataset.index;

      $$('.bc-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');

      $$('.bc-gallery__image').forEach(function(el) {
        el.classList.remove('is-active');
        var v = el.tagName === 'VIDEO' ? el : el.querySelector('video');
        if (v) v.pause();
      });

      var target = els.galleryMain.querySelector('[data-index="' + index + '"]');
      if (target) {
        target.classList.add('is-active');
        var vid = target.querySelector('video');
        if (vid) vid.play().catch(function() {});
      }
    });
  }


  // ── FAQ ────────────────────────────────────────────────────

  function initFAQ() {
    els.faqBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer = btn.nextElementSibling;

        els.faqBtns.forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
          b.nextElementSibling.setAttribute('aria-hidden', 'true');
        });

        if (!expanded) {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-open');
          answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }


  // ── UI Update ─────────────────────────────────────────────

  var CHECK_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function updateUI() {
    var hasDogs = state.dogCount > 0;
    var hasColour = state.colour !== '';
    var allPhotosUploaded = hasDogs && state.dogs.length > 0 && state.dogs.every(function(d) { return d.uploaded; });
    var anyUploading = state.dogs.some(function(d) { return d.uploading; });
    var allNamesEntered = hasDogs && state.dogs.length > 0 && state.dogs.every(function(d) { return d.name.trim().length > 0; });
    var variantAvailable = state.matchedVariant && state.matchedVariant.available;
    var ready = hasDogs && hasColour && allPhotosUploaded && !anyUploading && allNamesEntered && variantAvailable;

    // ── Step 1 (Dogs) badge ──
    if (hasDogs) {
      els.step1Num.classList.remove('is-active');
      els.step1Num.classList.add('is-done');
      els.step1Num.innerHTML = CHECK_SVG;
    } else {
      els.step1Num.classList.add('is-active');
      els.step1Num.classList.remove('is-done');
      els.step1Num.textContent = '1';
    }

    // ── Step 2 (Colour) unlock + badge ──
    if (hasDogs) {
      els.step2.classList.remove('bc-step--disabled');
      els.step2.classList.add('bc-step--enabled');
    } else {
      els.step2.classList.add('bc-step--disabled');
      els.step2.classList.remove('bc-step--enabled');
    }

    if (hasColour) {
      els.step2Num.classList.remove('is-active');
      els.step2Num.classList.add('is-done');
      els.step2Num.innerHTML = CHECK_SVG;
    } else if (hasDogs) {
      els.step2Num.classList.add('is-active');
      els.step2Num.classList.remove('is-done');
      els.step2Num.textContent = '2';
    } else {
      els.step2Num.classList.remove('is-active');
      els.step2Num.classList.remove('is-done');
      els.step2Num.textContent = '2';
    }

    // ── Step 3 (Photos) unlock + badge ──
    if (hasDogs && hasColour) {
      els.step3.classList.remove('bc-step--disabled');
      els.step3.classList.add('bc-step--enabled');
    } else {
      els.step3.classList.add('bc-step--disabled');
      els.step3.classList.remove('bc-step--enabled');
    }

    if (allPhotosUploaded) {
      els.step3Num.classList.remove('is-active');
      els.step3Num.classList.add('is-done');
      els.step3Num.innerHTML = CHECK_SVG;
    } else if (hasDogs && hasColour) {
      els.step3Num.classList.add('is-active');
      els.step3Num.classList.remove('is-done');
      els.step3Num.textContent = '3';
    } else {
      els.step3Num.classList.remove('is-active');
      els.step3Num.classList.remove('is-done');
      els.step3Num.textContent = '3';
    }

    // ── Step 4 (Names) unlock + badge ──
    if (allPhotosUploaded) {
      els.step4.classList.remove('bc-step--disabled');
      els.step4.classList.add('bc-step--enabled');
    } else {
      els.step4.classList.add('bc-step--disabled');
      els.step4.classList.remove('bc-step--enabled');
    }

    if (allNamesEntered) {
      els.step4Num.classList.remove('is-active');
      els.step4Num.classList.add('is-done');
      els.step4Num.innerHTML = CHECK_SVG;
    } else if (allPhotosUploaded) {
      els.step4Num.classList.add('is-active');
      els.step4Num.classList.remove('is-done');
      els.step4Num.textContent = '4';
    } else {
      els.step4Num.classList.remove('is-active');
      els.step4Num.classList.remove('is-done');
      els.step4Num.textContent = '4';
    }

    // ── Process steps ──
    if (allPhotosUploaded) {
      els.proc1.classList.remove('is-active');
      els.proc1.classList.add('is-done');
      els.proc1.querySelector('.bc-proc-step__icon').innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A7C59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      els.proc2.classList.add('is-active');
    } else {
      els.proc1.classList.add('is-active');
      els.proc1.classList.remove('is-done');
      els.proc1.querySelector('.bc-proc-step__icon').innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D4849A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>';
      els.proc2.classList.remove('is-active');
    }

    // ── CTA text ──
    var ctaCopy;
    if (!hasDogs) {
      ctaCopy = 'Select how many dogs to get started';
    } else if (!hasColour) {
      ctaCopy = 'Choose your bottle colour';
    } else if (anyUploading) {
      ctaCopy = 'Uploading photo\u2026';
    } else if (!allPhotosUploaded) {
      var uploadedCount = state.dogs.filter(function(d) { return d.uploaded; }).length;
      if (state.dogCount === 1) {
        ctaCopy = 'Upload your photo';
      } else {
        var remaining = state.dogCount - uploadedCount;
        ctaCopy = 'Upload ' + remaining + ' more photo' + (remaining !== 1 ? 's' : '');
      }
    } else if (!allNamesEntered) {
      if (state.dogCount === 1) {
        ctaCopy = "Enter your dog\u2019s name";
      } else {
        ctaCopy = "Enter all dog names";
      }
    } else if (state.matchedVariant && !state.matchedVariant.available) {
      ctaCopy = 'Sold Out \u2014 Try Another Colour';
    } else if (ready) {
      ctaCopy = 'Add to Basket \u2014 ' + formatMoney(state.matchedVariant.price);
    } else {
      ctaCopy = 'Select how many dogs to get started';
    }

    els.ctaText.textContent = ctaCopy;
    els.addBtn.disabled = !ready;

    if (ready) {
      els.addBtn.classList.add('is-ready');
    } else {
      els.addBtn.classList.remove('is-ready');
    }

    // Keep hidden properties inputs in sync with state on EVERY UI update.
    // This is load-bearing: Smart Cart's click handler (sc-drawer-v2.js:489)
    // reads `new FormData(form)` the instant the Add button is clicked, BEFORE
    // the form's submit event fires. If bc-hidden-props is empty at that moment,
    // properties[*] never reach Shopify and orders arrive with zero personalisation
    // data (incident BAC-UK-38982 / -38984 / -39038).
    rebuildHiddenProps();

    // ── Mobile sticky CTA sync ──
    if (els.stickyBtn) {
      els.stickyText.textContent = ctaCopy;
      els.stickyBtn.disabled = !ready;
      if (ready) {
        els.stickyBtn.classList.add('is-ready');
      } else {
        els.stickyBtn.classList.remove('is-ready');
      }
    }
  }


  // ── Form Submit ───────────────────────────────────────────

  // Build the line-item properties payload directly from state.
  // Mirrors the keys that rebuildHiddenProps() writes as hidden inputs,
  // so that the canonical /cart/add.js POST carries the same data the
  // form would have submitted natively.
  function buildProperties() {
    var props = {};
    props['Dogs']   = state.dogOption || '';
    props['Colour'] = state.colour || '';
    for (var i = 0; i < state.dogs.length; i++) {
      var n = i + 1;
      var dog = state.dogs[i];
      props['Image_' + n] = dog.photoUrl || '';
      props['Name_'  + n] = sanitizeName(dog.name).trim();
    }
    props['Font'] = bcFontLabel(state.fontStyle || 'classic');
    props['_Font code'] = state.fontStyle || 'classic';
    return props;
  }

  // Submit via fetch to /cart/add.js so properties are carried in the
  // JSON body. This bypasses any global form-submit interception (e.g.
  // Smart Cart) that was stripping the properties[*] hidden inputs and
  // landing orders with zero personalisation data (BAC-UK-38982/-38984).
  function submitToCart(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    }).then(function(resp) {
      if (!resp.ok) {
        return resp.text().then(function(txt) {
          var msg = 'Add to cart failed (' + resp.status + ')';
          try { var j = JSON.parse(txt); if (j.description) msg = j.description; } catch(_) {}
          throw new Error(msg);
        });
      }
      return resp.json();
    }).then(function(item) {
      var drawerHandled = false;
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        try { window.CartDrawer.refresh(); } catch(_) {}
        if (typeof window.CartDrawer.open === 'function') {
          try { window.CartDrawer.open(true); drawerHandled = true; } catch(_) {}
        }
      }
      try { document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true })); } catch(_) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated',  { bubbles: true, detail: { item: item } })); } catch(_) {}
      if (!drawerHandled) {
        setTimeout(function() { window.location.href = '/cart'; }, 400);
      }
      return item;
    });
  }

  var isSubmitting = false;
  function handleSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return false;
    if (!state.dogCount || !state.colour || !state.matchedVariant) return false;

    for (var i = 0; i < state.dogs.length; i++) {
      if (!state.dogs[i].uploaded || !state.dogs[i].photoUrl) {
        alert('Please upload a photo for Dog ' + (i + 1));
        return false;
      }
      if (!state.dogs[i].name.trim()) {
        alert('Please enter a name for Dog ' + (i + 1));
        return false;
      }
    }

    if (!state.matchedVariant.available) {
      alert('This combination is currently sold out. Please try a different colour.');
      return false;
    }

    isSubmitting = true;
    rebuildHiddenProps(); // keep DOM hidden inputs in sync for any analytics/listeners
    submitToCart(state.matchedVariant.id, buildProperties()).catch(function(err) {
      console.error('Cart add failed:', err);
      alert(err.message || 'Unable to add to cart. Please try again.');
      isSubmitting = false;
    });
  }

  function handleStickyClick() {
    if (state.matchedVariant && state.matchedVariant.available &&
        state.dogs.length > 0 &&
        state.dogs.every(function(d) { return d.uploaded && d.name.trim(); })) {
      if (isSubmitting) return;
      isSubmitting = true;
      rebuildHiddenProps();
      submitToCart(state.matchedVariant.id, buildProperties()).catch(function(err) {
        console.error('Cart add failed:', err);
        alert(err.message || 'Unable to add to cart. Please try again.');
        isSubmitting = false;
      });
    } else {
      // Scroll to the first incomplete step
      var target;
      if (!state.dogCount) {
        target = els.step1;
      } else if (!state.colour) {
        target = els.step2;
      } else if (!state.dogs.every(function(d) { return d.uploaded; })) {
        target = els.step3;
      } else {
        target = els.step4;
      }
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }


  // ── Colour Swatch Init ─────────────────────────────────────

  function initColourSwatches() {
    els.colourSwatches.forEach(function(btn) {
      var colourName = btn.dataset.colour;
      var fill = btn.querySelector('.bc-colour-swatch__fill');
      if (!fill) return;

      // Look up hex from the map using handleized name
      var handleized = colourName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
      var hex = COLOUR_HEX[handleized];

      if (hex) {
        fill.style.backgroundColor = hex;
      } else {
        // Fallback: show a neutral grey with the colour name as tooltip
        fill.style.backgroundColor = '#CCCCCC';
        console.warn('No hex mapping for colour:', colourName, '(handleized:', handleized + ')');
      }

      // White colours need a visible border
      if (WHITE_COLOURS.indexOf(handleized) > -1) {
        fill.classList.add('bc-colour-swatch__fill--white');
      }
    });
  }


  // ── Init ──────────────────────────────────────────────────

  function init() {
    cacheDom();

    if (!els.step1) return; // Not on the right page

    // Colour swatches — apply hex colours
    initColourSwatches();

    // Dog pills
    els.dogPills.forEach(function(btn) {
      btn.addEventListener('click', handleDogCountSelect);
    });

    // Colour swatches
    els.colourSwatches.forEach(function(btn) {
      btn.addEventListener('click', handleColourSelect);
    });

    // Font style buttons
    els.fontBtns.forEach(function(btn) {
      btn.addEventListener('click', handleFontSelect);
    });

    // Gallery
    initGallery();

    // FAQ
    initFAQ();

    // Form submit
    els.addForm.addEventListener('submit', handleSubmit);

    // Sticky CTA
    if (els.stickyBtn) {
      els.stickyBtn.addEventListener('click', handleStickyClick);
    }

    // Initial UI state
    updateUI();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
